<template>
    <div class="admin">
        <form style="margin-bottom:10px;">
            <a-row type="flex" justify="start">
                <a-col :span="8">
                    <a-row :gutter="10">
                        <a-col :span="11">
                            <a-input v-model="keyword" placeholder="请输入关键词" />
                        </a-col>
                        <a-col :span="3">
                            <a-button type="primary" @click="get_data()">搜索</a-button>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="2">
                    <a-button type="primary" @click="add_model=true,info_add={pic:''}" v-if="$Func.check_rank('merchant_add')">添加网点</a-button>
                </a-col>
            </a-row>
        </form>
        <a-table :columns="columns" :data-source="tableData" @change="change_filter" :loading="loading" :pagination="page" bordered>
            <template slot="user" slot-scope="text, record">
                <div v-if="record.uid===0">所有用户</div>
                <div v-else>
                    {{record.users_truename}}
                    ({{record.users_mobile}})
                </div>
            </template>
            <template slot="pic" slot-scope="text, record">
                <div v-if="record.pic" class="pics">
                    <a-badge :count="record.pic.length"><a href="javascript:void(0);" @click="show_pic(record.pic)"><img :src="record.pic[0].url" /></a></a-badge>
                </div>
            </template>
            <template slot="operation" slot-scope="text, record">
                <a @click="()=>{update_data(record)}" v-if="$Func.check_rank('merchant_add')">编辑</a>
                <a-divider type="vertical" />
                <a @click="()=>{delete_data(record)}" v-if="$Func.check_rank('source_del')">删除</a>
            </template>
        </a-table>
        <a-drawer
          title="增加网点"
          :width="750"
          :maskStyle="{backgroundColor: '#00000010'}"
          :visible="add_model"
          :body-style="{ paddingBottom: '80px' }"
          @close="add_model=false"
           v-if="$Func.check_rank('merchant_add')"
        >
            <a-form-model :model="info_add" :rules="add_rules" layout="vertical" @submit="add_data" ref="add_form">
                <a-form-model-item ref="title" prop="title" label="网点名称">
                    <a-input v-model="info_add.title" />
                </a-form-model-item>
				
				<a-form-model-item ref="pic" prop="pic" label="网点图片">
				    <a-upload name="imgFile" :multiple="true" list-type="picture" class="upload-list-inline" :action="base_url+'?action=api.ed_upload&adm_id='+$store.state.info.id+'&token='+$store.state.info.token" :file-list="info_add.pic" @change="picUpdateChange">
				        <a-button> <a-icon type="upload" /> 上传图片 </a-button>
				    </a-upload>
				</a-form-model-item>
				
				
				
				<a-row :gutter="20">
				    <a-col :span="24">
						<a-form-model-item ref="address" prop="address" label="地址">
							<a-input v-model="info_add.address" />
						</a-form-model-item>
				    </a-col>
				</a-row>		
				
				<a-row :gutter="20">
				    <a-col :span="24">
						<a href="https://lbs.qq.com/getPoint/" target="_blank">经纬度获取</a>
						<br/>
						<br/>
				    </a-col>
				</a-row>		
				
				<a-row :gutter="20">
				    <a-col :span="24">
						<a-form-model-item ref="lng" prop="lng" label="经度">
							<a-input v-model="info_add.lng" />
						</a-form-model-item>
				    </a-col>
				</a-row>		
				
				<a-row :gutter="20">
				    <a-col :span="24">
						<a-form-model-item ref="lat" prop="lat" label="纬度">
							<a-input v-model="info_add.lat" />
						</a-form-model-item>
				    </a-col>
				</a-row>	
				
                <a-form-model-item ref="content" prop="content" label="备注说明">
                    <AEditor
                        v-model="info_add.content"
                    />
                </a-form-model-item>
                <div :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1,
                }">
                    <a-button :style="{ marginRight: '8px' }" @click="add_model=false">
                        取消
                    </a-button>
                    <a-button type="primary" html-type="submit">
                        确定
                    </a-button>
                </div>
            </a-form-model>
        </a-drawer>
        <Pics />
    </div>
</template>

<script>
    import Func from '../../common/func';
    import Pics from '../../components/Pics';
    import AEditor from '../../components/AEditor';
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        // {
        //     title: '用户',
        //     dataIndex: 'users_username',
        //     key: 'users_username',
        //     width: 200,
        //     scopedSlots: { customRender: 'user' },
        // },
        {
            title: '添加人',
            dataIndex: 'admin',
            key: 'admin',
        },
        {
            title: '网点名称',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: '网点图片',
            dataIndex: 'pic',
            key: 'pic',
            width: 130,
            scopedSlots: { customRender: 'pic' },
        },
        {
            title: '网点地址',
            dataIndex: 'address',
            key: 'address',
        },
        // {
        //     title: '备注说明',
        //     dataIndex: 'content',
        //     key: 'content',
        // },
        {
            title: '创建时间',
            dataIndex: 'created',
            key: 'created',
            width: 180,
        },
        {
            title: '修改时间',
            dataIndex: 'modified',
            key: 'modified',
            width: 180,
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: 180,
            key:'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    let add_timeout;
    let update_timeout;
    let search_timeout;
    export default {
        name: 'Info',
        components: {AEditor,Pics},
        data(){
            return {				
                base_url:Func.api_url,
                pic_url:Func.pic_url,
				
                columns,
                form: this.$form.createForm(this),
                keyword:'',
                tableData:[],
                loading:false,
                add_model:false,
                update_model:false,

                search_fetching: false,
                search_user_value:undefined,
                search_user_list:[],


                add_fetching: false,
                update_fetching: false,
                add_user_value:undefined,
                update_user_value:undefined,
                add_user_list:[],
                update_user_list:[],
                group_list:[],
                info_add:{
                    title:'',
                    content:'',
					pic:'',
                },
                add_rules: {
                    title:[{ required: true, message: '标题不能为空', trigger: 'blur' }],
                },
                page:{
                    current:1,
                    total:0,
                    pageSize:10
                }
            }
        },
        mounted() {
            this.get_data();
        },
        methods: {
            show_pic(data){
                this.$PubSub.publish('show_pics',data);
            },
			
			picUpdateChange(info) {
			    let fileList = [...info.fileList];
			
			    // 2. read from response and show file link
			    fileList = fileList.map(file => {
			        if (file.response) {
			            // Component will show file.url as link
			            file.url = this.pic_url+file.response.url;
			        }
			
			        return file;
			    });
			
			    console.log(fileList);
			    // this.info_update.pic = fileList;
			    this.info_add.pic = fileList;
			},
			beforeUpload(file) {
			    const isLt2M = file.size / 1024 / 1024 < 200;
			    if (!isLt2M) {
			        this.$message.error('请上传200M以内文件!');
			    }
			    return isLt2M;
			},
			
            //指定用户 begin
            searchUserSearch(keyword) {
                if (search_timeout) {
                    clearTimeout(search_timeout);
                    search_timeout = null;
                }
                search_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.search_user_list = res.info.list;
                    });
                }, 300);
            },
            searchUserChange(value) {
                this.search_user_value=value;
            },


            //指定用户 begin
            addUserSearch(keyword) {
                if (add_timeout) {
                    clearTimeout(add_timeout);
                    add_timeout = null;
                }
                add_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.add_user_list = res.info.list;
                    });
                }, 300);
            },
            addUserChange(value) {
                this.info_add.uid = value;
                this.add_user_value=value;
            },
            updateReferrerSearch(keyword) {
                if (update_timeout) {
                    clearTimeout(update_timeout);
                    update_timeout = null;
                }
                update_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.update_user_list = res.info.list;
                    });
                }, 300);
            },
            updateReferrerChange(value) {
                this.info_update.uid = value;
                this.update_user_value=value;
            },
            //指定用户 end
            change_filter(pagination){
                this.get_data(pagination.current);
            },
            get_data(page,tip) {
                var keyword = this.keyword;
                if (!page) {
                    page = this.page.current||1;
                }

                if(!tip){
                    this.loading = true
                }

                Func.url_get({
                    action:'bid.merchant_list',
                    uid:this.search_user_value||'',
                    keyword: keyword,
                    page: page
                },(res) => {
					if (res.error === 0) {
						this.tableData = res.info.list;
						var pagination={
							pageSize:10,
							total:res.info.foot.total,
							current:parseInt(res.info.foot.current)
						}
						this.page=pagination;
						this.loading = false
					} else {
						this.$message.error(res.info);
					}
                });
            },

            add_data(e){
                e.preventDefault();
				console.log(111);
                this.$refs.add_form.validate(valid => {
                    if (valid) {
                        var pic=this.info_add.pic;
						var pics="";
						if( pic!='' ){							
							pics=pic.map(file=>{
							    return file.url;
							})
						}
						console.log(pic);
						console.log(99);
                        Func.url_post({
                            action:'bid.merchant_add',
                            ...this.info_add,
                            pic:pics
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.add_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },
			update_data(res){
                const item=JSON.parse(JSON.stringify(res));
                Func.url_get({
                    action:'bid.merchant_find',
                    id:item.id
                },(res) => {
                    this.info_add = res.info;
                });
				this.add_model = true;
            },

            delete_data(item){
                if(confirm('确定要删除吗')==true){
                    Func.url_get({
                        action:'bid.merchant_del',
                        id:item.id
                    },(res) => {
                        if(res.error===0){
                            this.$message.success(res.info);
                            this.get_data(1,true);
                        }else{
                            this.$message.error(res.info);
                        }
                    });
                }
            },
            goto_url(url,id){
                this.$router.push({
                    path:'/admin/'+url,
                    params:{
                        id:id
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
	.pics img{
	    max-width: 100px;
	    max-height: 100px;
	}
</style>